/**
 * @file 带返回按钮的 Header，通常作为 Page 的一部分
 */

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons'
import { Icon } from '@seiue/ui'
import React from 'react'
import styled from 'styled-components'

import { useHistory } from 'packages/route'


export interface HeaderProps {
  title?: string
  extra?: React.ReactNode
  style?: React.CSSProperties
  useBack?: boolean
}

export const Header: React.FC<HeaderProps> = ({
  title,
  style,
  extra,
  useBack = true,
}) => {
  const history = useHistory()

  return (
    <Wrapper style={style}>
      <Bottom>
        <Left>
          {useBack ? (
            <Back data-test-id="back" onClick={history.goBack}>
              <Icon icon={faArrowLeft} />
            </Back>
          ) : null}
          <Title data-test-id="页面标题">{title}</Title>
        </Left>
        <div>{extra}</div>
      </Bottom>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-bottom: 20px;
`

const Bottom = styled.div`
  display: flex;
  justify-content: space-between;
`

const Left = styled.div`
  display: flex;
  align-items: center;
`

const Back = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 28px;
  margin-right: 12px;
  background: rgba(50, 56, 66, 0.06);
  border-radius: 6px;
  cursor: pointer;
`

const Title = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0;
`
